import React, { type ReactNode } from "react";
import "./KPICard.css";

interface KPICardProps {
  label: string;
  value: string;
  delta?: number | null;
  trend?: "up" | "down" | "flat" | "na";
  prefix?: string;
  icon?: ReactNode;
  onClick?: () => void;
}

const KPICard: React.FC<KPICardProps> = ({ label, value, delta = null, trend = "na", prefix, icon, onClick }) => {
  const ta = trend === "up" ? "\u2191" : trend === "down" ? "\u2193" : "";
  const isClickable = !!onClick;

  return (
    <div
      onClick={onClick}
      className={`offers-kpi-card trend-${trend} ${isClickable ? "clickable" : ""}`}
    >
      <div className="offers-kpi-card-glow" />
      <div className="offers-kpi-card-content">
        <div className="offers-kpi-card-header">
          <p className="offers-kpi-card-label">{label}</p>
          {icon && <span className="offers-kpi-card-icon">{icon}</span>}
        </div>
        <p className="offers-kpi-card-value">
          {prefix && <span className="offers-kpi-card-prefix">{prefix}</span>}{value}
        </p>
        {delta != null && trend !== "na" && <span className="offers-kpi-card-delta">{ta} {Math.abs(delta)}%</span>}
      </div>
    </div>
  );
};

export default KPICard;
